import type { ProtonThunkArguments } from '@proton/redux-shared-store-types'

export interface DocsThunkArguments extends ProtonThunkArguments {}

export const extraThunkArguments = {} as DocsThunkArguments
